<!--ALERT MODAL-->
<ui-modal [templateModal]="templateModalEnum.WARNING" [isOpenModal]="openWarningModal">
  <ng-container body>
    <p class="font-bold mb-5">
      {{ 'Attenzione' }}
    </p>
    <p>
      {{ 'Confermando perderai i dati ricercati. Vuoi confermare?' }}
    </p>
  </ng-container>
  <ng-container footer>
    <div class="mx-10 mb-4 flex w-full justify-center" [ngClass]="{'mx-10': !isMobile}">
      <ui-button
        class="modal__custom-button mr-2.5"
        [label]="'Annulla' | uppercase"
        [buttonType]="buttonType.OUTLINE"
        [isRounded]="true"
        (click)="closeModal(false)"
      ></ui-button>
      <ui-button
        class="modal__custom-button"
        [label]="'Conferma' | uppercase"
        [buttonType]="buttonType.PRIMARY"
        [isRounded]="true"
        (click)="closeModal(true)"
      ></ui-button>
    </div>
  </ng-container>
</ui-modal>
